import { createAction } from '@reduxjs/toolkit';

export const actionTypes = {
  SET_ACTIVE: 'teamleader/Navigation/SET_ACTIVE',
  CLICK_ITEM: 'teamleader/Navigation/CLICK_ITEM',
  ADD_MODULE_COUNT: 'teamleader/Navigation/ADD_MODULE_COUNT',
  SET_NAVIGATION_CONFIG: 'teamleader/Navigation/SET_NAVIGATION_CONFIG',
  TOGGLE_TERTIARY_NAVIGATION_VISIBILITY: 'teamleader/Navigation/TOGGLE_TERTIARY_NAVIGATION_VISIBILITY',
  OVERRIDE: 'teamleader/Navigation/OVERRIDE',
  RELEASE: 'teamleader/Navigation/RELEASE',
};

export interface Config {
  mode: string;
  backButtonRoute: null;
}

export const actionCreators = {
  setActive: createAction(actionTypes.SET_ACTIVE, ({ parents }: { parents: string[]; match: string }) => ({
    payload: parents || [],
  })),
  clickItem: createAction<{ level: number; pathname: string; tracking?: string }>(actionTypes.CLICK_ITEM),
  addModuleCount: createAction(actionTypes.ADD_MODULE_COUNT, (moduleId: string, count: number) => ({
    payload: {
      moduleId,
      count,
    },
  })),
  initializeTertiaryNavigation: createAction(actionTypes.TOGGLE_TERTIARY_NAVIGATION_VISIBILITY, () => ({
    payload: true,
  })),
  destroyTertiaryNavigation: createAction(actionTypes.TOGGLE_TERTIARY_NAVIGATION_VISIBILITY, () => ({
    payload: false,
  })),
  setNavigationConfig: createAction<Config>(actionTypes.SET_NAVIGATION_CONFIG),
  override: createAction<{ level: 'secondary'; config: Config }>(actionTypes.OVERRIDE),
  release: createAction(actionTypes.RELEASE),
};
